// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_mx_switch/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_mx_switch: ModuleSchema = {
  "id": "core_mx_switch",
  "uniqueId": "B3D_MXSW1",
  "createdAt": "2026-10-02T01:45:00Z",
  "updatedAt": "2026-10-28T14:58:32.449Z",
  "label": "MX Switch Core",
  "description": "Cherry MX Mechanical Switch & Socket pair built from the core_geometry/mx_switch.h primitive",
  "category": "core_geometry",
  "tags": [
    "core-geometry",
    "CG_MXSW01",
    "cherry_mx"
  ],
  "sliders": [
    {
      "key": "displayMode",
      "label": "Display Mode (0:Both, 1:Switch, 2:Seat)",
      "min": 0,
      "max": 2,
      "default": 0,
      "step": 1,
      "unit": "",
      "integerOnly": true,
      "enabled": true,
      "visible": true
    },
    {
      "key": "socketW",
      "label": "Socket Cavity Width (X)",
      "min": 12,
      "max": 16,
      "default": 14.2,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "socketD",
      "label": "Socket Cavity Depth (Y)",
      "min": 13,
      "max": 18,
      "default": 15.9,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "housingW",
      "label": "Switch Housing Width",
      "min": 12,
      "max": 16,
      "default": 14,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "housingD",
      "label": "Switch Housing Depth",
      "min": 12,
      "max": 16,
      "default": 14,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "stemArm",
      "label": "Cross Stem Arm Length",
      "min": 3,
      "max": 5,
      "default": 4,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "stemThick",
      "label": "Cross Stem Thickness",
      "min": 0.8,
      "max": 1.5,
      "default": 1.1,
      "step": 0.05,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "stemH",
      "label": "Cross Stem Height",
      "min": 2,
      "max": 6,
      "default": 4,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "switch_seat",
      "label": "Switch Seat Socket Block",
      "default": "#1E293B",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "switch_sim",
      "label": "Cherry MX Switch Solid",
      "default": "#DC2626",
      "targetGroupIds": [
        1
      ]
    }
  ],
  "objects": [
    {
      "id": "obj_seat",
      "label": "Switch Seat Assembly",
      "name": "Switch Seat Assembly",
      "color": "#1E293B",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "switch_seat",
          "label": "Switch Seat Socket Block",
          "name": "Switch Seat Socket Block",
          "groupId": 0,
          "colorKey": "switch_seat",
          "defaultColor": "#1E293B",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        }
      ]
    },
    {
      "id": "obj_switch",
      "label": "Cherry MX Switch Simulation",
      "name": "Cherry MX Switch Simulation",
      "color": "#DC2626",
      "assembled_z_offset": 0,
      "exploded_z_offset": 35,
      "parts": [
        {
          "id": "switch_sim",
          "label": "Cherry MX Switch Solid",
          "name": "Cherry MX Switch Solid",
          "groupId": 1,
          "colorKey": "switch_sim",
          "defaultColor": "#DC2626",
          "assembled_z_offset": 0,
          "exploded_z_offset": 35,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Full Assembly"
    },
    {
      "id": "0",
      "label": "Download STL - Switch Seat (Hốc cắm)"
    },
    {
      "id": "1",
      "label": "Download STL - Switch Simulation (Khối Switch)"
    }
  ]
};
